import React from "react";

import { formatDate, json } from "helpers/data";
import { App, Version } from "../download-center.service";
import ServerImage from "components/server-image/server-image";
import { useTranslation } from "react-i18next";
// import { css } from "@emotion/css";
// import moment from "moment";
import VersionDownload from "assets/images/svg/version_download_white.svg";
import Rating from "pages/details/components/rating";
import {client} from "helpers/client";
import { useAuthContext } from "store/auth";
import { useNavigate } from "react-router-dom";

interface Props {
  app: App;
  index: number;
  ip:any
}

function DownloadAppSection({ app, index,ip }: Props) {
  return (
    <div className="dexef-one">
      <div className={"row " + (index % 2 === 0 ? "" : "hover-background")}>
        <div className="col-xl-3 col-lg-6 col-md-6">
          <div className="box-info">
            <ServerImage className="app-logo" src={app.logo.fullPath} alt="DexefLogo" />
            <h1>{json(app.title)}</h1>
            <div className="rate">
              <span className="number">{app.rate?.averageRate}</span>
              <Rating rating={app.rate?.averageRate} readOnly />
              <span className="downloadNumber">({app.rate?.count ?? 0})</span>
            </div>
          </div>
        </div>

        {app.versions?.map((version) => (
          <VersionCard key={version.id} version={version} ip={ip} />
        ))}
      </div>
    </div>
  );
  // return (
  //   <div className="row">
  //     <div className="col-12">
  //       <div className="appName">
  //         <ServerImage src={app.logo.fullPath} />
  //         <h2>{json(app.title)}</h2>
  //       </div>
  //     </div>
  //
  //     {app.versions?.map((version) => (
  //       <VersionCard key={version.id} version={version} />
  //     ))}
  //   </div>
  // );
}

function VersionCard({ version,ip }: { version: Version,ip:any }) {
  const { t } = useTranslation("download-center");
  const [{isLoggedIn}] = useAuthContext()
  const navigate = useNavigate();

  function downloadVersion(downloadUrl: string) {
    if (isLoggedIn) {
      client("/customer/versionDownloadCount", {
        data: {
          versionId: version.id,
          ipAddress: ip
        }
      });
      window.open(downloadUrl);
    } else {
      navigate("/login?return-url=/download-center");
    }
  }

  return (
    <div className="col-xl-3 col-lg-6 col-md-6">
      <div className="box-app">
        <ServerImage className="logo" src={version.logo.fullPath} alt="DexefOne" />
        <h1 className="title">{json(version.name)}</h1>
        <p className="version">{version.releaseNumber ?? "1.0.0"}</p>
        <p className="info">{json(version.shortDescription)}</p>
        <div className="size-released">
          {/*<h2 className='size'>Size:206 MB</h2>*/}
          <h2 className="released">
            {t("released")}: {formatDate(version.lastUpdatedOn!)}
          </h2>
        </div>
        <button disabled={!version.downloadUrl} onClick={() => downloadVersion(version.downloadUrl)} className="btn-center">
          <img src={VersionDownload} alt="VersionDownload" />
          {t("download")}
        </button>
      </div>
    </div>
  );

  //   return (
  //     <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
  //       <div className="box-app">
  //         <div className="head">
  //           <div className="logo">
  //             <ServerImage src={version.logo.fullPath} alt="img" />
  //           </div>
  //           <div className="content">
  //             <h3>{json(version.name)}</h3>
  //             {version.lastUpdatedOn && <p>Last updated on {moment(version.lastUpdatedOn).format("D MMM yyyy")}</p>}
  //           </div>
  //         </div>
  //         <p
  //           className={css`
  //             line-break: anywhere;
  //           `}
  //           dangerouslySetInnerHTML={{ __html: json(version.shortDescription) }}
  //         />
  //         <button disabled={!version.downloadUrl} onClick={downloadVersion(version.downloadUrl)} className="btn-download">
  //           {t("download")}
  //         </button>
  //       </div>
  //
  //       {/* <div className="box-app2">
  //
  // <div className='logo'>
  //     <ServerImage src={version.logo.fullPath} alt="img"/>
  // </div>
  //
  // <div className='content'>
  // <h3>{json(version.name)}</h3>
  //     {version.lastUpdatedOn && <p>Last updated on {moment(version.lastUpdatedOn).format('D MMM yyyy')}</p>}
  //     <p className={css`line-break: anywhere`} dangerouslySetInnerHTML={{__html: json(version.shortDescription)}}/>
  // <button disabled={!version.downloadUrl} onClick={downloadVersion(version.downloadUrl)} className='btn-download'>{t('download')}</button>
  // </div>
  // </div> */}
  //     </div>
  //   );
}

export default DownloadAppSection;
